import * as yup from 'yup'
import { PersonAddressDto, PersonDto } from 'dtos'

export class BuildABoxFedExOutboundLabelManagementDto {
  fedExOutboundTrackingNumber?: string | null = undefined
  fedExOutboundPackageType?: string | null = undefined
  fedExOutboundShipDate?: string | null = undefined
  fedExOutboundShipTime?: string = undefined
  fedExOutboundDeliveryType?: string | null = undefined
  fedExOutboundWeight?: number | null = undefined
  fedExOutboundTitleClerk?: PersonDto = undefined
  fedExOutboundTitleClerkAddress?: PersonAddressDto = undefined
}

export const buildABoxFedExOutboundLabelManagementValidationSchema = yup.object({
  // fedExOutboundPackageType: yup.string().required('FedEx Outbound Package Type is required.'),
  // fedExOutboundShipDate: yup.string().required('FedEx Outbound Ship Date is required.'),
  // fedExOutboundShipTime: yup.string().required('FedEx Outbound Ship Time is required.'),
  // fedExOutboundDeliveryType: yup.string().required('FedEx Outbound Delivery Type is required.'),
  // fedExOutboundWeight: yup.number().required('FedEx Outbound Weight is required.')
  // fedExOutboundTitleClerk: yup.object().required('FedEx Outbound Title Clerk is required.'),
  // fedExOutboundTitleClerkAddress: yup.object().required('FedEx Outbound Title Clerk Address is required.')
})
